import axios from 'axios';

export async function getByCampaign(collection: string, campaignId: string): Promise<unknown> {
    const results = await axios.get(`/api/collections/${collection}/campaign/${campaignId}`);
    return results.data;
}
